"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.teamRoutes = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_router_1 = require("react-router");
const appConstants_1 = require("../../constants/appConstants");
const pageLoader_1 = __importDefault(require("../loaders/pageLoader"));
const rootLoader_1 = require("../loaders/rootLoader");
const teamsCardsLoader_1 = require("../loaders/team/teamsCardsLoader");
const teamsCodingLoader_1 = require("../loaders/team/teamsCodingLoader");
const teamsOverviewLoader_1 = require("../loaders/team/teamsOverviewLoader");
const teamsPeopleLoader_1 = require("../loaders/team/teamsPeopleLoader");
const protectedRoute_1 = __importDefault(require("../protectedRoute"));
const Root_1 = require("../Root");
const TeamOverview = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('../../components/pages/teamSettings/overview'))));
const TeamCards = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('../../components/pages/teamSettings/cards'))));
const TeamPeople = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('../../components/pages/teamSettings/people'))));
const TeamCoding = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('../../components/pages/teamSettings/accountingCodes'))));
const teamPath = '/team';
exports.teamRoutes = {
    path: teamPath,
    element: (0, jsx_runtime_1.jsx)(react_router_1.Outlet, {}),
    children: [
        {
            path: 'overview',
            element: ((0, jsx_runtime_1.jsx)(protectedRoute_1.default, { allowedRoles: [...appConstants_1.defaultAllowedRoles, appConstants_1.teamAdmin], children: (0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)(pageLoader_1.default, {}), children: (0, jsx_runtime_1.jsx)(TeamOverview, {}) }) })),
            loader: async (ctx) => {
                const [rootData, overviewData] = await Promise.all([
                    (0, rootLoader_1.rootLoader)({ queryClient: Root_1.queryClient, ...ctx }),
                    (0, teamsOverviewLoader_1.teamsOverviewLoader)({ queryClient: Root_1.queryClient, ...ctx }),
                ]);
                return {
                    ...rootData,
                    ...overviewData,
                };
            },
        },
        {
            path: 'cards',
            element: ((0, jsx_runtime_1.jsxs)(protectedRoute_1.default, { allowedRoles: [...appConstants_1.defaultAllowedRoles, appConstants_1.teamAdmin], children: [' ', (0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)(pageLoader_1.default, {}), children: (0, jsx_runtime_1.jsx)(TeamCards, {}) })] })),
            loader: async (ctx) => {
                const [rootData, teamData] = await Promise.all([
                    (0, rootLoader_1.rootLoader)({ queryClient: Root_1.queryClient, ...ctx }),
                    (0, teamsCardsLoader_1.teamsCardsLoader)({ queryClient: Root_1.queryClient, ...ctx }),
                ]);
                return {
                    ...rootData,
                    ...teamData,
                };
            },
        },
        {
            path: 'people',
            element: ((0, jsx_runtime_1.jsxs)(protectedRoute_1.default, { allowedRoles: [...appConstants_1.defaultAllowedRoles, appConstants_1.teamAdmin], children: [' ', (0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)(pageLoader_1.default, {}), children: (0, jsx_runtime_1.jsx)(TeamPeople, {}) })] })),
            loader: async (ctx) => {
                const [rootData, teamData] = await Promise.all([
                    (0, rootLoader_1.rootLoader)({ queryClient: Root_1.queryClient, ...ctx }),
                    (0, teamsPeopleLoader_1.teamsPeopleLoader)({ queryClient: Root_1.queryClient, ...ctx }),
                ]);
                return {
                    ...rootData,
                    ...teamData,
                };
            },
        },
        {
            path: 'coding',
            element: ((0, jsx_runtime_1.jsxs)(protectedRoute_1.default, { allowedRoles: [...appConstants_1.defaultAllowedRoles, appConstants_1.teamAdmin], children: [' ', (0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)(pageLoader_1.default, {}), children: (0, jsx_runtime_1.jsx)(TeamCoding, {}) })] })),
            loader: async (ctx) => {
                const [rootData, teamData] = await Promise.all([
                    (0, rootLoader_1.rootLoader)({ queryClient: Root_1.queryClient, ...ctx }),
                    (0, teamsCodingLoader_1.teamsCodingLoader)({ queryClient: Root_1.queryClient, ...ctx }),
                ]);
                return {
                    ...rootData,
                    ...teamData,
                };
            },
        },
    ],
};
